<script setup lang="ts">
import { computed } from 'vue'

import usePmsiStayListTable from '@/stay-list/stay-list-table/composables/pmsiStayListTable'
import { ListMcoStay } from '@/stay-list/stay-list-table/mco/types'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const props = withDefaults(defineProps<{
  openQuickViewStayId?: number | null
}>(), {
  openQuickViewStayId: null
})

const emit = defineEmits<{
  (e: 'open-quick-view', stay: ListMcoStay): void
}>()

const openQuickViewStayId = computed(() => props.openQuickViewStayId)
const PmsiStayListTable = usePmsiStayListTable<ListMcoStay>(PmsiTypeEnum.MCO, (stay) => emit('open-quick-view', stay), openQuickViewStayId)
</script>

<template>
  <component :is="PmsiStayListTable" />
</template>